// extracted by mini-css-extract-plugin
export default {"zoomModal":"J1-z","image":"K1-z","button":"L1-z","isOverlayShown":"M1-z"};